const {GlobalEvent} = require("./global-event");

const GlobalMouseUp = ({fn}) =>
    GlobalEvent({
        eventName: "mouseup",
        fn,
    });
exports.GlobalMouseUp = GlobalMouseUp;
